module.exports = __webpack_public_path__ + "media/images/element/04-3c3aa4d270bbcdd7ebd30daaf92c81be.png";